import { SpaceView } from "containers/folders/hooks/utils";
import { formatMessage } from "lib/globalize-util";
import { IFolderSelection } from "../folder-selection/folder-navigation";

export const getParentItem = (
    currentParent?: IFolderSelection,
    merchantSpace?: nuorder.folder.v1.Space,
    mySpace?: nuorder.folder.v1.Space,
    membership?: nuorder.merchant.v1.Member
) => {
    const isParentFolderMerchantSpace = merchantSpace?.root_item_id === currentParent?.id;
    const isParentFolderMySpace = mySpace?.root_item_id === currentParent?.id;

    if (isParentFolderMerchantSpace) {
        return {
            ...currentParent,
            name: formatMessage("|Merchant| Drive", {
                merchant: membership?.merchant_ref?.name ?? membership?.merchant_id,
            }),
        };
    }

    if (isParentFolderMySpace) {
        return {
            ...currentParent,
            name: formatMessage("My Drive"),
        };
    }

    // it means merchant space or my spaces are not pulled yet.
    if (currentParent?.name === "__root__") {
        return null;
    }

    return currentParent;
};

export const getParentItemWithWriteAccess = (parentItem: IFolderSelection, mySpace: nuorder.folder.v1.Space) => {
    if (!parentItem) {
        return null;
    }
    const defaultItem = mySpace
        ? {
              ...mySpace,
              name: formatMessage("My Drive"),
              space: mySpace.id,
              id: mySpace.root_item_id,
          }
        : parentItem;
    if (parentItem?.isDrive) {
        return parentItem?.spaceView === SpaceView.SharedWithMe ? defaultItem : parentItem;
    }

    return parentItem?.capabilities?.can_add_children ? parentItem : defaultItem;
};
